import { SuccessResponseList } from './common'

export enum UserStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  DISABLED = 'disabled',
}

/**
 * Scope level enumeration for role assignments.
 * Defines the hierarchical level at which a role applies.
 */
export enum ScopeType {
  ORGANIZATION = 'organization',
  COMPANY = 'company',
  PROJECT = 'project',
  DELIVERABLE_SET = 'deliverable_set',
}

/**
* Scope detail DTO with enriched entity metadata.

Represents a single scope assignment with hierarchical entity information.
All fields are nullable to handle soft-deleted entities gracefully.
*/
export interface ScopeDetail {
  /** Company UUID from project hierarchy */
  company_id?: string | null
  /** Company name (null if company deleted) */
  company_name?: string | null
  /** Deliverable set UUID if scope is deliverable_set level */
  deliverable_set_id?: string | null
  /** Deliverable set name (null if deleted) */
  deliverable_set_name?: string | null
  /** Project UUID if scope is project or deliverable_set level */
  project_id?: string | null
  /** Project name (null if project deleted) */
  project_name?: string | null
  /** Scope level type for filtering and validation */
  scope_type?: ScopeType
}

/**
* Role assignment DTO with enriched scope details.

Groups multiple scope assignments under a single role.
Empty scopes list indicates organization-level role assignment.
*/
export interface RoleWithScopes {
  /** Permission action strings for this role (e.g., ['file:view', 'file:manage']) */
  permissions?: string[]
  /** Role UUID */
  role_id: string
  /** Role name */
  role_name: string
  /** Optional role description from backend */
  description?: string
  /** List of scopes where this role applies. Empty list = organization-wide access. */
  scopes?: ScopeDetail[]
  /** Timestamp when role was assigned */
  assigned_at?: string
  /** User who assigned this role */
  assigned_by?: string
}

/**
 * DTO for user response data.
 * AdminServiceOrchestrationUserDtoUserDtoResponseUser
 */
export interface User {
  avatar_url?: string | null
  created_at?: string | null
  created_by?: string | null
  deleted_by?: string | null
  email: string
  entra_oid?: string | null
  first_name: string
  id: string
  last_name: string
  /**
   * System roles assigned to the user. Used for RBAC evaluation.
   */
  roles?: RoleWithScopes[]
  status?: string | null
  updated_at?: string | null
  updated_by?: string | null
}

export interface SuccessResponsePaginatedResponseResponseUser extends SuccessResponseList<User> {}
